export const BLANK_ROUTE = '/';
export const NOT_FOUND_ROUTE = '/not-found';
export const FORGOT_PASSWORD_ROUTE = '/forgot-password';
export const RESET_PASSWORD_ROUTE = '/reset-password';
export const PROFILE_ROUTE = '/profile';
export const ADMIN_HOME_ROUTE = '/admin-home';
export const COLLECTION_LIST_ROUTE = '/collections';
export const COLLECTION_CREATE_ROUTE = COLLECTION_LIST_ROUTE + '/new';
export const COLLECTION_UPDATE_ROUTE = COLLECTION_LIST_ROUTE + '/update';
export const COLLECTION_PREVIEW_ROUTE = COLLECTION_LIST_ROUTE + '/view/:id/3';
export const COLLECTION_PRODUCT_PREVIEW_ROUTE =
  COLLECTION_LIST_ROUTE + '/preview';
export const COLLECTION_COPY_ROUTE = COLLECTION_LIST_ROUTE + '/copy';
export const FEATURED_PRODUCTS_ROUTE = '/featured-products';
export const FEATURED_PRODUCT_CREATE_ROUTE = FEATURED_PRODUCTS_ROUTE + '/new';
export const FEATURED_PRODUCT_UPDATE_ROUTE = FEATURED_PRODUCTS_ROUTE + '/edit';
export const FEATURED_PRODUCT_PREVIEW_ROUTE = FEATURED_PRODUCTS_ROUTE + '/view';
export const FEATURED_PRODUCT_DELETE_ROUTE =
  FEATURED_PRODUCTS_ROUTE + '/delete';
export const SEASON_LIST_ROUTE = '/manage-seasons';
export const SEASON_CREATE_ROUTE = SEASON_LIST_ROUTE + '/new';
export const SEASON_UPDATE_ROUTE = SEASON_LIST_ROUTE + '/edit';
export const SEASON_PREVIEW_ROUTE = SEASON_LIST_ROUTE + '/view';
export const SEASON_DELETE_ROUTE = SEASON_LIST_ROUTE + '/delete';
export const DESTINATION_LIST_ROUTE = '/destinations';
export const DESTINATION_CREATE_ROUTE = DESTINATION_LIST_ROUTE + '/new';
export const DESTINATION_UPDATE_ROUTE = DESTINATION_LIST_ROUTE + '/edit';
export const DESTINATION_PREVIEW_ROUTE = DESTINATION_LIST_ROUTE + '/view';
export const WEB_SERVICE_ROUTE = '/web-service';
export const WEB_SERVICE_CREATE_ROUTE = WEB_SERVICE_ROUTE + '/new';
export const WEB_SERVICE_UPDATE_ROUTE = WEB_SERVICE_ROUTE + '/update';
export const WEB_SERVICE_TEST_ROUTE = WEB_SERVICE_ROUTE + '/test';
export const NEWS_ROUTE = '/news';
export const NEWS_CREATE_ROUTE = NEWS_ROUTE + '/new';
export const NEWS_UPDATE_ROUTE = NEWS_ROUTE + '/update';
export const COVER_IMAGE_ROUTE = '/image-cover';
export const COVER_IMAGE_CREATE_ROUTE = COVER_IMAGE_ROUTE + '/new';
export const COVER_IMAGE_UPDATE_ROUTE = COVER_IMAGE_ROUTE + '/edit';
export const COVER_IMAGE_PREVIEW_ROUTE = COVER_IMAGE_ROUTE + '/view';
export const DOCUMENT_ROUTE = '/documents';
export const DOCUMENT_CREATE_ROUTE = DOCUMENT_ROUTE + '/new';
export const DOCUMENT_UPDATE_ROUTE = DOCUMENT_ROUTE + '/edit';
export const DOCUMENT_PREVIEW_ROUTE = DOCUMENT_ROUTE + '/view';
export const EXTERNAL_LINK_ROUTE = '/manage-link';
export const EXTERNAL_LINK_CREATE_ROUTE = EXTERNAL_LINK_ROUTE + '/new';
export const EXTERNAL_LINK_UPDATE_ROUTE = EXTERNAL_LINK_ROUTE + '/edit';
export const EXTERNAL_LINK_PREVIEW_ROUTE = EXTERNAL_LINK_ROUTE + '/view';
export const STATIC_CONTENT_ROUTE = '/static-content';
export const STATIC_CONTENT_CREATE_ROUTE = STATIC_CONTENT_ROUTE + '/new';
export const STATIC_CONTENT_UPDATE_ROUTE = STATIC_CONTENT_ROUTE + '/update';
export const MESSAGE_ROUTE = '/messages';
export const MESSAGE_CREATE_ROUTE = MESSAGE_ROUTE + '/new';
export const MESSAGE_UPDATE_ROUTE = MESSAGE_ROUTE + '/update';
export const GROUPS_ROUTE = '/groups';
export const GROUPS_CREATE_ROUTE = GROUPS_ROUTE + '/new';
export const GROUPS_UPDATE_ROUTE = GROUPS_ROUTE + '/update';
export const BRAND_ROUTE = '/brand';
export const BRAND_CREATE_ROUTE = BRAND_ROUTE + '/new';
export const BRAND_UPDATE_ROUTE = BRAND_ROUTE + '/edit';
export const BRAND_PREVIEW_ROUTE = BRAND_ROUTE + '/view';
export const USER_ROUTE = '/user';
export const USER_CREATE_ROUTE = USER_ROUTE + '/new';
export const USER_UPDATE_ROUTE = USER_ROUTE + '/edit';
export const USER_PREVIEW_ROUTE = USER_ROUTE + '/view';
export const USER_ASSIGNMENT_ROUTE = USER_ROUTE + '/assignment';
export const USER_ASSIGNMENT_ADD_ROUTE = USER_ASSIGNMENT_ROUTE + '/add';
export const USER_ASSIGNMENT_UPDATE_ROUTE = USER_ASSIGNMENT_ROUTE + '/edit';
export const USER_ASSIGNMENT_VIEW_ROUTE = USER_ASSIGNMENT_ROUTE + '/view';
export const SEASON_WORKBENCH_LIST_ROUTE = '/season-workbench';
export const SEASON_WORKBENCH_CREATE_ROUTE =
  SEASON_WORKBENCH_LIST_ROUTE + '/create';
export const SEASON_WORKBENCH_EDIT_ROUTE =
  SEASON_WORKBENCH_LIST_ROUTE + '/edit';
export const EXPIRED_CART_ROUTE = '/expired-carts';
export const EXPIRED_CART_PREVIEW_ROUTE = EXPIRED_CART_ROUTE + '/view';
export const ROLE_ROUTE = '/role';
export const ROLE_CREATE_ROUTE = ROLE_ROUTE + '/new';
export const ROLE_UPDATE_ROUTE = ROLE_ROUTE + '/edit';
export const ROLE_PREVIEW_ROUTE = ROLE_ROUTE + '/view';
export const ROLE_ASSIGNMENT_ROUTE = ROLE_ROUTE + '/assignment';
export const MENU_ROUTE = '/menu';
export const MENU_CREATE_ROUTE = MENU_ROUTE + '/new';
export const MENU_UPDATE_ROUTE = MENU_ROUTE + '/edit';
export const MENU_DRAG_ROUTE = MENU_ROUTE + '/drag';

export const LINESHEET_ROUTE = '/global-linesheet';
export const LINESHEET_CREATE_ROUTE = LINESHEET_ROUTE + '/create';
export const LINESHEET_UPDATE_ROUTE = LINESHEET_ROUTE + '/update';
export const LINESHEET_COPY_ROUTE = LINESHEET_ROUTE + '/copy';
export const LINESHEET_SHARE_ROUTE = LINESHEET_ROUTE + '/share';

export const PRODUCTS_ROUTE = LINESHEET_ROUTE + '/products';
export const COLLECTION_ROUTE = LINESHEET_ROUTE + '/collections';
export const PRODUCTS_DETAIL_ROUTE = LINESHEET_ROUTE + '/product';

export const RED_START = 1;
export const RED_END = 5;
export const ORANGE_START = RED_END;
export const ORANGE_END = 20;
export const GREEN_START = ORANGE_END;
export const securityRoute = [PROFILE_ROUTE];

export const MAINTENANCE_URL = 'maintenance';
export const PROPOSALS_ROUTE = '/proposals/events';
